export default __webpack_public_path__ + "static/media/gal1.ee4e88bb.jpg";